import React from 'react';
import { Grid, Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { withStyles } from '../../mui-styles-bridge.js';
import IconBanner from './Icon/IconBanner';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckIcon from '@mui/icons-material/Check';
import {
  FormFailuresText,
  getFailedUploadsBanner,
} from './util/SubmissionUtil';

const styles = {
  snackbar: {
    maxWidth: '500px',
    width: '90%',
    margin: '0 auto',
  },
  snackbarContent: {
    backgroundColor: 'white',
    padding: '16px',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    '@media (max-width: 600px)': {
      padding: '12px',
    },
  },
};

class SaveDialog extends React.Component {
  constructor(props) {
    super(props);
    this.timer = null;
  }

  componentDidMount() {
    this.setAutoCloseTimer();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open && this.props.open) {
      this.setAutoCloseTimer();
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  setAutoCloseTimer = () => {
    if (this.props.open) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.props.close();
      }, 5000);
    }
  };

  getFileUploadsBanner = (failedSave, failedUploads) => {
    const hasFailedUploads =
      failedUploads && Object.keys(failedUploads).length > 0;

    if (hasFailedUploads) return getFailedUploadsBanner(failedUploads);
    else if (!failedSave) {
      return <MuiAlert severity="success">Uploaded files saved</MuiAlert>;
    }

    return <></>;
  };

  render() {
    const { classes, formFailures, open, close } = this.props;
    const { failedUploads, failedSave } = formFailures;

    return (
      <Snackbar
        open={open}
        onClose={close}
        className={classes.snackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Grid container spacing={2} className={classes.snackbarContent}>
          <Grid item xs={12}>
            {!failedSave ? (
              <MuiAlert severity="success">Form data saved</MuiAlert>
            ) : (
              <MuiAlert severity="error">
                Form data could not be saved. Please try again.
              </MuiAlert>
            )}
          </Grid>
          <Grid item xs={12}>
            {this.getFileUploadsBanner(failedSave, failedUploads)}
          </Grid>
        </Grid>
      </Snackbar>
    );
  }
}

export default withStyles(styles)(SaveDialog);
